import { FluidOutputReportResponse } from "../../services/api/types/forms/responses/FluidOutputReportResponse";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FluidOutputHistoryResponse } from "../../services/api/types/forms/responses/FluidOutputHistoryResponse";
import { RootState } from "../../services/store";

type ResidentId = number;

interface State {
  fluidOutput: Record<ResidentId, FluidOutputReportResponse[]>;
}

const initialState: State = {
  fluidOutput: {},
};

export const fluidOutputSlice = createSlice({
  name: "fluidOutput",
  initialState,
  reducers: {
    storeFluidOutput: (
      state,
      action: PayloadAction<FluidOutputHistoryResponse>,
    ) => {
      const { data } = action.payload;
      data.forEach((entry) => {
        const residentId = entry.resident.id;
        if (!state.fluidOutput[residentId]) {
          state.fluidOutput[residentId] = [];
        }

        // Check if the entry already exists
        const exists = state.fluidOutput[residentId].some(
          (existingEntry) => existingEntry.id === entry.id,
        );
        if (!exists) {
          state.fluidOutput[residentId].push(entry);
        }
      });
    },
  },
});

export const { storeFluidOutput } = fluidOutputSlice.actions;

export const selectResidentFluidOutputLogs = createSelector(
  [
    (state: RootState) => state.fluidOutput?.fluidOutput,
    (_: RootState, residentId?: number) => residentId,
  ],
  (fluidOutput, residentId) =>
    !residentId ? [] : fluidOutput?.[residentId] || [],
);

export default fluidOutputSlice.reducer;
